import { clevertapEvent } from 'utils/clevertap';

const EVENTS = {
  navigate: 'Stream Compose Setting Viewed',
  action: 'Comment Management Action',
};
const ACTIONS = {
  selectSetting: 'Comment Management Compose Setting Selected',
  chooseSetting: 'Comment Management Choose Who Can Comment Selected',
  changeSetting: 'Comment Management Change Who Can Comment Selected',
};
const DEFAULT_USER = 'Author';

const CommentAnalytics = {
  Navigate: {
    ViewPage: () => {
      clevertapEvent(EVENTS.navigate);
    },
  },
  Action: {
    CommentInfo: () => {
      clevertapEvent(EVENTS.action, {
        Action: ACTIONS.selectSetting,
        'User Type': DEFAULT_USER,
      });
    },
    ChangeComment: () => {
      clevertapEvent(EVENTS.action, {
        Action: ACTIONS.changeSetting,
      });
    },
    ChooseComment: (selected) => {
      clevertapEvent(EVENTS.action, {
        Action: ACTIONS.chooseSetting,
        'Choose Who Can Comment': selected,
      });
    },
  },
};

export default CommentAnalytics;
